import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import 'react-responsive-modal/styles.css'
import { usePopupFeedback } from '../../hooks/usePopupFeedback'
  import { useSurveyByCode }  from '../../hooks/useSurveyByCode'
import SurveyRenderer       from './SurveyRenderer/SurveyRenderer'
import './surveyModal.css'

export default function PopupSurveyModal({ surveyType: propSurveyType, courseCode }) {
  const isFirstLogin = localStorage.getItem('firstLogin') === 'true'
  let surveyType;
  if (typeof propSurveyType !== 'undefined' && propSurveyType !== null) {
    surveyType = propSurveyType;
  } else if (isFirstLogin) {
    surveyType = "after_first_login";
  } else {
    surveyType = "popup_period";
  }
  const { avail, start, submit } = usePopupFeedback(30000, surveyType, courseCode)
  const [open, setOpen] = useState(false)
  const [code, setCode] = useState(null)
  const survey = useSurveyByCode(code, !!code)
  useEffect(() => {
    if (avail && avail.data && avail.data.hasAny && !open) {
      const first = avail.data.forms[0]
      setCode(first.code)
      start.mutate(first.code)
      setOpen(true)
    }
  }, [avail.data, open, start])
  const handleClose  = () => { setOpen(false); setCode(null) }
  const handleSubmit = async answers => {
    await submit.mutateAsync({ formCode: code, answers })
  }
  if (survey.isLoading || survey.error || !survey.data) {
    return null
  }
  return (
    <Modal
      open={open}
      onClose={handleClose}
      center
      closeOnEsc
      closeOnOverlayClick={false} 
      styles={{ modal: { padding: 0 } }}
    >
      <SurveyRenderer survey={survey.data} onSubmit={handleSubmit}/>
    </Modal>
  )
}
